export const SENDING_AXIOS = "SENDING_AXIOS";
export const SET_AXIOS_RESULT = "SET_AXIOS_RESULT";
export const CLEAN_AXIOS_RESULT = "CLEAN_AXIOS_RESULT";
export const INTERNAL_ERROR = "INTERNAL_ERROR";
export const INFRA_SET_HEADER_SIZE = "INFRA_SET_HEADER_SIZE";
export const INFRA_RESIZE = "INFRA_RESIZE";

export const FETCH_SERVICE_TOKENS = "FETCH_SERVICE_TOKENS";
export const FETCHED_SERVICE_TOKENS = "FETCHED_SERVICE_TOKENS";

export const FETCH_STATISTICS = "FETCH_STATISTICS";
export const FETCHED_STATISTICS = "FETCHED_STATISTICS";
